module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-cell"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Cell")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-cell', {
    attrs: {
      "title": "单元格1",
      "value": "单元格1内容"
    }
  }), _vm._v(" "), _c('zan-cell', {
    attrs: {
      "title": "单元格2",
      "value": "单元格2内容"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("标题带描述信息")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-cell', {
    attrs: {
      "title": "单元格1",
      "label": "描述信息",
      "is-link": "",
      "url": "javascript:void(0)"
    },
    on: {
      "click": _vm.handleClick
    }
  }), _vm._v(" "), _c('zan-cell', {
    attrs: {
      "title": "单元格2",
      "label": "描述信息"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("带图标")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-cell', {
    attrs: {
      "title": "起码运动馆",
      "icon": "home"
    }
  }), _vm._v(" "), _c('zan-cell', {
    attrs: {
      "title": "线下门店",
      "icon": "location"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("可点击的链接")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-cell', {
    attrs: {
      "title": "起码运动馆",
      "value": "进入店铺",
      "icon": "home",
      "url": "http://youzan.com",
      "is-link": ""
    }
  }), _vm._v(" "), _c('zan-cell', {
    attrs: {
      "title": "线下门店",
      "icon": "location",
      "url": "http://youzan.com",
      "is-link": ""
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("高级用法")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-cell', {
    attrs: {
      "value": "进入店铺",
      "icon": "home",
      "url": "http://youzan.com",
      "is-link": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "zan-cell-text"
  }, [_vm._v("起码运动馆")]), _vm._v(" "), _c('img', {
    staticClass: "official-img",
    attrs: {
      "src": "//su.yzcdn.cn/v2/image/account/icon_guan_160421.png"
    }
  })])], 2), _vm._v(" "), _c('zan-cell', {
    attrs: {
      "title": "线下门店",
      "icon": "location",
      "url": "http://youzan.com",
      "is-link": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ec3c846!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/cell.vue
// module id = 250
// module chunks = 0